import { useChildComponentRouteV2 } from '@gogame/screens';

import { CONCEPT_ID } from 'scenes/Gallery/GalleryPage/constants';

import ConceptDetails from './index';

export const ConceptDetailsRouteElement = () => {
  return useChildComponentRouteV2(
    ConceptDetails,
    {},
    {
      idKey: CONCEPT_ID,
    }
  );
};
